<!--
    @name: widget-switch
    @description：widget-switch
    @author: ZengWei
    @date: 2022-03-25 09:36
-->
<template>
  <div>
    <div v-if="disabled" class="input-show">{{element.value === element.config['active-value'] ? '是' : '否' }}</div>
    <el-switch
      v-else
      v-model="element.value"
      :disabled="disabled"
      @change="triggerInteractive"
      :active-value="element.config['active-value'] ?? true"
      :inactive-value="element.config['inactive-value'] ?? false"
      ></el-switch>
  </div>
</template>

<script>
import {Switch} from "element-ui";
import formItemMinix from "@/custom-component/form/newParser/scripts/formItemMinix";

export default {
  name: "WidgetSwitch",
  components: {
    'el-switch': Switch
  },
  mixins: [formItemMinix],
  props: ['element', 'disabled', 'displayData'],
  data() {
    return {}
  },
  created() {
    if (this.element.value === this.element.config['active-value']||this.element.value === true) {
      this.element.value = this.element.config['active-value'] ?? true;
    } else {
      this.element.value = this.element.config['inactive-value'] ?? false;
    }
    this.triggerInteractive(this.element.value,'auto')
  },
  methods: {
  },
}
</script>

<style scoped>

</style>
